import { render } from "./WText.vue?vue&type=template&id=11b0f1bf&scoped=true"
import script from "./WText.vue?vue&type=script&lang=js"
export * from "./WText.vue?vue&type=script&lang=js"

import "./WText.vue?vue&type=style&index=0&id=11b0f1bf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b0f1bf"]])

export default __exports__